import { render } from "./OtherPaymentGovfees.vue?vue&type=template&id=5e0fb174"
import script from "./OtherPaymentGovfees.vue?vue&type=script&lang=js"
export * from "./OtherPaymentGovfees.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__